import React from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import TopupsTable from '../components/TopupsTable';

const LoanTopupsPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <TopupsTable></TopupsTable>
    </Container>
  )
}
export default withAuth (LoanTopupsPage, ['admin', 'agent'])